// DS2.2
import React from 'react';
import classnames from 'classnames';
import PlainButtonOrLink, { Props as BaseButtonProps } from '../PlainButtonOrLink';
import { Props as IconProps } from '../../Icons/IconWrap';
import { ButtonSize } from '../types';
import useIconSizeForButtonSize from '../hooks/useIconSizeForButtonSize';
import s from './GhostButton.scss';

export interface Props extends BaseButtonProps {
  size: ButtonSize;
  icon?: React.ComponentType<IconProps>;
  postfixIcon?: React.ComponentType<IconProps>;
  variant: 'main' | 'approval-green' | 'destructive-red' | 'edit-purple' | 'core-orange';
  rounded?: boolean;
  children?: React.ReactNode;
}

const GhostButton: React.FC<Props> = ({
  size,
  variant,
  fillContainerWidth,
  className,
  children,
  icon: IconComponent,
  postfixIcon: PostFixIconComponent,
  loading,
  rounded,
  ...props
}) => {
  const iconSize = useIconSizeForButtonSize(size);

  return (
    <PlainButtonOrLink
      className={classnames(
        className,
        s['root'],
        s[`variant-${variant}`],
        s[`size-${size}`],
        fillContainerWidth && s['fill-container-width'],
        rounded && s['rounded'],
        props.disabled && s['disabled'],
        loading && s['loading']
      )}
      {...props}
    >
      {IconComponent && (
        <IconComponent className={s['icon']} size={iconSize} disableDefaultColors />
      )}
      <span className={s['content']}>{children}</span>
      {PostFixIconComponent && (
        <PostFixIconComponent className={s['icon']} size={iconSize} disableDefaultColors />
      )}
    </PlainButtonOrLink>
  );
};
GhostButton.displayName = 'GhostButton';

export default GhostButton;
